import { createLogRocketTelemetry, sanitizeTelemetryUrl } from "@homesusa/core";

const RESOURCE_SEGMENTS = new Set(["users"]);

export const logRocketTelemetry = createLogRocketTelemetry({
  appId: process.env.REACT_APP_LOGROCKET_APP_ID ?? "",
  enabled: () =>
    process.env.REACT_APP_LOGROCKET_ENABLED?.trim().toLowerCase() === "true",
  sessionStorageKey: "usermanagement_logrocket_session_id",
  startEventName: "UserManagement LogRocket started",
  sanitizeUrl: (url) =>
    sanitizeTelemetryUrl(url, { resourceSegments: RESOURCE_SEGMENTS })
});
